import { render } from "./report-details-modal.vue?vue&type=template&id=ccc2dace"
import script from "./report-details-modal.vue?vue&type=script&lang=js"
export * from "./report-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__